"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Dashboard;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MyData_1 = __importDefault(require("./MyData"));
//import News from "../News";
const OffersCard_1 = __importDefault(require("./OffersCard"));
const MainSetupReact_1 = __importDefault(require("../../../MainSetupReact"));
const InvoicesCard_1 = __importDefault(require("./InvoicesCard"));
const ApplicationCallsCard_1 = __importDefault(require("./ApplicationCallsCard"));
const MilestonesCard_1 = __importDefault(require("./MilestonesCard"));
const CyberSecurityCard_1 = __importDefault(require("./CyberSecurityCard"));
/** Rady bezpieczeństwa dostają osoby pracujące na naszych danych. Poza wykazem
 * zostają EXTERNAL_USER i CLIENT - decyzja właściciela. */
const CYBER_SECURITY_ROLES = [
    "ADMIN",
    "ENVI_MANAGER",
    "ENVI_EMPLOYEE",
    "ENVI_COOPERATOR",
    "CONTRACT_WORKER",
];
function Dashboard() {
    const currentUser = MainSetupReact_1.default.currentUserOrNull;
    (0, react_1.useEffect)(() => {
        document.title = "Witryna projektów";
    }, []);
    if (!currentUser) {
        return (react_1.default.createElement(react_bootstrap_1.Row, { className: "mx-3" },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "mb-0" }, "Trwa pobieranie danych u\u017Cytkownika. Widok zostanie za\u0142adowany po potwierdzeniu sesji."))));
    }
    return (react_1.default.createElement(react_bootstrap_1.Row, { className: "mx-3" },
        react_1.default.createElement(react_bootstrap_1.Col, { md: 3, className: "mb-3" },
            MainSetupReact_1.default.STAFF_ROLES.includes(currentUser.systemRoleName) && (react_1.default.createElement(OffersCard_1.default, { className: "mb-3 bg-white" })),
            ["ADMIN", "ENVI_MANAGER"].includes(currentUser.systemRoleName) && (react_1.default.createElement(InvoicesCard_1.default, { className: "mb-3 bg-white" })),
            MainSetupReact_1.default.STAFF_ROLES.includes(currentUser.systemRoleName) && (react_1.default.createElement(ApplicationCallsCard_1.default, { className: "mb-3 bg-white" }))),
        react_1.default.createElement(react_bootstrap_1.Col, { md: 6, className: "mb-3" }, MainSetupReact_1.default.CONTRACT_SCOPED_ROLES.includes(currentUser.systemRoleName) && (react_1.default.createElement(MilestonesCard_1.default, null))),
        react_1.default.createElement(react_bootstrap_1.Col, { md: 3, className: "mb-3" },
            react_1.default.createElement(MyData_1.default, { className: "mb-3 bg-white" }),
            CYBER_SECURITY_ROLES.includes(currentUser.systemRoleName) && (react_1.default.createElement(CyberSecurityCard_1.default, { className: "mb-3 bg-white" })))));
}
